function countdown(targetDate) {
    return {
      target: new Date(targetDate),
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',

      start() {
        this.update()
        setInterval(() => this.update(), 1000)
      },

      update() {
        const now = new Date()
        const distance = this.target - now

        if (distance <= 0) {
          this.days = this.hours = this.minutes = this.seconds = '00'
          return
        }

        this.days = this.pad(Math.floor(distance / (1000 * 60 * 60 * 24)))
        this.hours = this.pad(Math.floor((distance / (1000 * 60 * 60)) % 24))
        this.minutes = this.pad(Math.floor((distance / (1000 * 60)) % 60))
        this.seconds = this.pad(Math.floor((distance / 1000) % 60))
      },

      pad(value) {
        return String(value).padStart(2, '0')
      }
    }
  }